<section *ngIf="renditionExists">
  <h1>{{ title }}</h1>
  <div class="rendition-content-container">
    <!-- --------------------------------- -->
    <!-- ---------- PROPIEDAD ------------ -->
    <!-- --------------------------------- -->
    <div class="title-section"><h2>Propiedad</h2></div>
    <div class="content-section">
      <div class="line-key-value">
        <span>Dirección:</span>{{ data.propertyAddress }}
      </div>
      <div class="line-key-value"><span>MLS-ID:</span>{{ data.mlsId }}</div>
      <div class="line-key-value">
        <span>Tipo de propiedad:</span>{{ data.propertyTypeTxt }}
      </div>
    </div>

    <!-- --------------------------------------------------------------- -->
    <!-- ----------AGENTE REFERENCIADOR / REFERIDO A COBRAR ------------ -->
    <!-- --------------------------------------------------------------- -->
    <ng-container *ngIf="data.renditionType == 2 || data.renditionType == 5">
      <div class="title-section"><h2>Agente referenciador</h2></div>
      <div class="content-section">
        <div class="line-key-value">
          <!-- (en el viejo los referidos se guardan como doble punta ↓) -->
          <span>Nombre</span
          >{{ data.organizationCommission.purchaseOrganizationName }}
        </div>
        <div class="line-key-value">
          <span>Refirió al cliente:</span
          >{{ this.NODE === this.NODE_DO ? "Captador" : "Vendedor" }}
        </div>
      </div>
    </ng-container>

    <!-- --------------------------------- -->
    <!-- ---- DATOS DE LA OPETACIÓN ------ -->
    <!-- --------------------------------- -->
    <div class="title-section"><h2>Datos de la operación</h2></div>
    <div class="sides">
      <div class="content-section">
        <div class="line-key-value"><span>Fecha:</span>{{ date }}</div>
        <div class="line-key-value">
          <span>Tipo de operación:</span>{{ data.operationTypeTxt }}
          <!-- CREDITO -->
          <ng-container *ngIf="data.operationType == 2"
            ><span>Crédito:</span>{{ data.credit ? "Sí" : "No" }}</ng-container
          >
          <!-- PERIODO ALQUILER -->
          <ng-container *ngIf="data.operationType != 2"
            ><span>Periodo:</span> {{ data.contractTime }}
            {{
              data.contractTimeType == 1
                ? "días"
                : data.contractTimeType == 2
                  ? "meses"
                  : "años"
            }}</ng-container
          >
        </div>
        <!-- BANCO Y GARANTIA  -->
        <div class="line-key-value" *ngIf="data.bankText">
          <span>{{ data.operationType == 2 ? "Banco" : "Garantía" }}:</span
          >{{ data.bankText }}
        </div>
        <div class="line-key-value">
          <span>Jurisdicción:</span>{{ data.jurisdictionTxt }}
        </div>
        <div class="line-key-value">
          <span>Compartida con:</span
          >{{ data.sharedBy == 2 ? "RE/MAX" : data.sharedByTxt }}

          <ng-container *ngIf="data.sharedBy == 2"
            ><span>Oficina:</span>{{ data.sharedAgencyName }}</ng-container
          >
          <ng-container *ngIf="data.sharedBy == 3"
            ><span>Inmobiliaria:</span
            >{{ displayFormat(data.otherRealEstate?.name) }}</ng-container
          >
        </div>
      </div>
      <div class="content-section">
        <h3>Precio de cierre</h3>
        <br />
        <div class="line-key-value">
          <span>Tipo de cambio:</span>
          <h3>{{ displayFormat(data.exchangeRate) }}</h3>
        </div>
        <div class="line-key-value">
          <span>U$S:</span>
          <h3>{{ displayFormat(data.totalAmountOperationUSD) }}</h3>
          <span>$:</span>
          <h3>{{ displayFormat(data.totalAmountOperationARS) }}</h3>
        </div>
        <div class="line-key-value" *ngIf="this.NODE === this.NODE_DO">
          <span>Comisiones pendientes:</span>
          <h3>{{ data.pendingCommissions ? "Sí" : "No" }}</h3>
        </div>
        <div
          class="line-key-value"
          *ngIf="this.NODE === this.NODE_DO && statisticsComputationLabel"
        >
          <span>Cómputo de estadísticas:</span>
          <h3>{{ statisticsComputationLabel }}</h3>
        </div>
      </div>
    </div>

    <!-- --------------------------------- -->
    <!-- -----------  PUNTAS  ------------ -->
    <!-- --------------------------------- -->
    <ng-container *ngIf="data.renditionType != 2 && data.renditionType != 5">
      <div class="title-section">
        <h2>
          Punta {{ this.NODE === this.NODE_DO ? "captadora" : "vendedora" }}
        </h2>
        <h2>
          Punta {{ this.NODE === this.NODE_DO ? "vendedora" : "compradora" }}
        </h2>
      </div>
      <ng-container>
        <div class="sides">
          <!-- PUNTA VENDEDORA -->
          <div class="content-section">
            <div class="line-key-value">
              <span>%</span>
              <h3>
                {{
                  displayFormat(
                    data.organizationCommission.purchaseCommissionPercentage
                  )
                }}
              </h3>
              <span>U$S</span>
              <h3>
                {{
                  displayFormat(data.organizationCommission.purchaseAmountUSD)
                }}
              </h3>
              <span>$</span>
              <h3>
                {{
                  displayFormat(data.organizationCommission.purchaseAmountARS)
                }}
              </h3>
            </div>
          </div>
          <!-- PUNTA VENDEDORA -->
          <div class="content-section">
            <div class="line-key-value">
              <span>%</span>
              <h3>
                {{
                  displayFormat(
                    data.organizationCommission.saleCommissionPercentage
                  )
                }}
              </h3>
              <span>U$S</span>
              <h3>
                {{ displayFormat(data.organizationCommission.saleAmountUSD) }}
              </h3>
              <span>$</span>
              <h3>
                {{ displayFormat(data.organizationCommission.saleAmountARS) }}
              </h3>
            </div>
          </div>
        </div>
        <!-- RELACION VENDEDOR/COMPRADOR -->
        <div class="sides">
          <div class="content-section">
            <div class="line-key-value">
              <span>{{
                this.NODE === this.NODE_DO ? "Captador" : "Vendedor"
              }}</span>
              <h3>
                {{ displayFormat(data.purchaseRelationshipPercentage) }} %
              </h3>
            </div>
          </div>
          <div class="content-section">
            <div class="line-key-value">
              <span>{{
                this.NODE === this.NODE_DO ? "Vendedor" : "Comprador"
              }}</span>
              <h3>{{ displayFormat(data.saleRelationshipPercentage) }} %</h3>
            </div>
          </div>
        </div>
        <!-- AGENTES VENDEDOR/COMPRADOR -->
        <div class="sides">
          <!-- Vendedor -->
          <div class="content-section">
            <h3 class="title-side">
              Agente {{ this.NODE === this.NODE_DO ? "captador" : "vendedor" }}
              <!-- TAG EXCLUSIVA -->
              <span class="tag" *ngIf="data.exclusivityType != 3">{{
                data.exclusivityTypeTxt
              }}</span>
            </h3>
            <!-- ORIGEN/OFICINA/INMOBILIARIA -->
            <div class="line-key-value">
              <ng-container *ngIf="sideSellerOwn; else noMyOffice">
                <span>Origen:</span>Mi oficina <span>Oficina:</span
                >{{ myOffice }}
              </ng-container>
              <ng-template #noMyOffice>
                <span>Origen:</span
                >{{ data.sharedBy == 2 ? "RE/MAX" : "Inmobiliaria" }}
                <ng-container *ngIf="data.sharedBy == 2"
                  ><span>Oficina: </span
                  >{{ data.sharedAgencyName }}</ng-container
                >
                <ng-container *ngIf="data.sharedBy == 3">{{
                  displayFormat(
                    data.otherRealEstate
                      ? data.otherRealEstate.name
                      : data.sharedAgencyName
                  )
                }}</ng-container>
              </ng-template>
            </div>
            <!-- NOMBRE DEL AGENTE VENDEDOR -->
            <div class="line-key-value">
              <span>Nombre agente:</span>
              {{
                displayFormat(
                  data.organizationCommission.purchaseOrganizationName
                )
              }}
            </div>
            <!-- ORIGEN DEL CLIENTE VENDEDOR -->
            <div class="line-key-value">
              <span>Origen del cliente:</span>
              {{ displayFormat(data.clientContact.saleCustomerOrigin) }}
            </div>
          </div>
          <!-- Comprador -->
          <div class="content-section">
            <h3 class="title-side">
              Agente {{ this.NODE === this.NODE_DO ? "vendedor" : "comprador" }}
              <!-- TAG EXCLUSIVA -->
              <span class="tag">{{ getTagExclusivityBuyer() }}</span>
            </h3>
            <!-- ORIGEN/OFICINA/INMOBILIARIA -->
            <div class="line-key-value">
              <ng-container *ngIf="sideBuyerOwn; else noMyOffice">
                <span>Origen: </span>Mi oficina <span>Oficina: </span
                >{{ myOffice }}
              </ng-container>
              <ng-template #noMyOffice>
                <span>Origen: </span
                >{{ data.sharedBy == 2 ? "RE/MAX" : "Inmobiliaria" }}.
                <ng-container *ngIf="data.sharedBy == 2"
                  ><span>Oficina: </span
                  >{{ data.sharedAgencyName }}</ng-container
                >
                <ng-container *ngIf="data.sharedBy == 3">{{
                  displayFormat(
                    data.otherRealEstate
                      ? data.otherRealEstate.name
                      : data.sharedAgencyName
                  )
                }}</ng-container>
              </ng-template>
            </div>
            <!-- NOMBRE DEL AGENTE COMPRADOR -->
            <div class="line-key-value">
              <span>Nombre agente:</span>
              {{
                displayFormat(data.organizationCommission.saleOrganizationName)
              }}
            </div>
            <!-- ORIGEN DEL CLIENTE COMPRADOR -->
            <div class="line-key-value">
              <span>Origen del cliente:</span>
              {{ displayFormat(data.clientContact.purchaseCustomerOrigin) }}
            </div>
          </div>
        </div>
        <!-- REFERIDOS VENDEDOR/COMPRADOR -->
        <div class="sides" *ngIf="referredList.seller || referredList.buyer">
          <!-- Vendedor -->
          <div class="content-section">
            <ng-container *ngIf="referredList.seller">
              <h3 class="title-side">Referido vendedor</h3>
              <div class="line-key-value">
                <span>Origen:</span>
                {{
                  referredList.seller.officeID == myOfficeID
                    ? "Mi oficina"
                    : referredList.seller.officeID == -1
                      ? "Otro"
                      : "RE/MAX"
                }}
                <span>Oficina:</span>
                {{
                  referredList.seller.officeID == myOfficeID
                    ? myOffice
                    : getOfficeName(referredList.seller.officeID)
                }}
              </div>
              <div class="line-key-value">
                <span>Nombre agente:</span>{{ referredList.seller.name }}
              </div>
            </ng-container>
          </div>
          <!-- Comprador -->
          <div class="content-section">
            <ng-container *ngIf="referredList.buyer">
              <h3 class="title-side">
                Referido
                {{ this.NODE === this.NODE_DO ? "vendedor" : "comprador" }}
              </h3>
              <div class="line-key-value">
                <span>Origen:</span>
                {{
                  referredList.buyer.officeID == myOfficeID
                    ? "Mi oficina"
                    : referredList.buyer.officeID == -1
                      ? "Otro"
                      : "RE/MAX"
                }}
                <span>Oficina:</span>
                {{
                  referredList.buyer.officeID == myOfficeID
                    ? myOffice
                    : getOfficeName(referredList.buyer.officeID)
                }}
              </div>
              <div class="line-key-value">
                <span>Nombre agente:</span>{{ referredList.buyer.name }}
              </div>
            </ng-container>
          </div>
        </div>
        <!-- TEAM LEADER VENDEDOR/COMPRADOR -->
        <div
          class="sides"
          *ngIf="
            dataCheckout.seller.teamLeader.name ||
            dataCheckout.buyer.teamLeader.name
          "
        >
          <!-- Vendedor -->
          <div
            class="content-section"
            *ngIf="dataCheckout.seller.teamLeader.name"
          >
            <h3 class="title-side">T. Leader</h3>
            <div class="line-key-value">
              <span>Nombre agente:</span
              >{{ dataCheckout.seller.teamLeader.name }}
            </div>
            <div class="line-key-value">
              <span>Origen de la captación:</span
              >{{ dataCheckout.seller.teamLeader.captationOrigin }}
            </div>
          </div>
          <!-- Comprador -->
          <div
            class="content-section"
            *ngIf="dataCheckout.buyer.teamLeader.name"
          >
            <h3 class="title-side">T. Leader</h3>
            <div class="line-key-value">
              <span>Nombre agente:</span
              >{{ dataCheckout.buyer.teamLeader.name }}
            </div>
            <div class="line-key-value">
              <span>Origen de la captación:</span
              >{{ dataCheckout.buyer.teamLeader.captationOrigin }}
            </div>
          </div>
        </div>

        <!-- COBROKER VENDEDOR -->
        <ng-container *ifNodeShow="[NODE_DO]">
          <ng-container *ngIf="dataCheckout.cobrokers.length > 0">
            <div
              class="sides"
              *ngFor="let cobroker of dataCheckout.cobrokers; let i = index"
            >
              <!-- Vendedor -->
              <div class="content-section" *ngIf="cobroker.name">
                <h3 class="title-side">Cobroker #{{ i + 1 }}</h3>
                <div class="line-key-value">
                  <div class="line-key-value">
                    <span>Nombre agente:</span>{{ cobroker.name }}
                  </div>
                </div>
              </div>

              <!-- Cobroker teamleader -->
              <div class="content-section" *ngIf="cobroker.teamLeader.name">
                <h3 class="title-side">T. Leader Cobroker #{{ i + 1 }}</h3>
                <div class="line-key-value">
                  <div class="line-key-value">
                    <span>Nombre agente:</span>{{ cobroker.teamLeader.name }}
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
    <!-- --------------------------------- -->
    <!-- ---------- FACTURAS ------------- -->
    <!-- --------------------------------- -->
    <div class="title-section" *ngIf="billingsList.length > 0">
      <h2>Facturas</h2>
    </div>
    <div class="content-section deduction" *ngIf="billingsList.length > 0">
      <!-- TABLA -->
      <div class="custom-table">
        <!-- table header -->
        <div class="t-header">
          <div class="column">Origen</div>
          <div class="column" [ngStyle]="{ width: '64px', flex: 'initial' }">
            Tipo
          </div>
          <div class="column">Agente</div>
          <div class="column">Monto</div>
          <div class="column">IVA</div>
        </div>
        <!-- table content -->
        <div class="t-row" *ngFor="let r of billingsList">
          <!-- Origen: agente a la oficina -->
          <div class="column">{{ r.origin }}</div>
          <!-- tipo de factura -->
          <div class="column" [ngStyle]="{ width: '64px', flex: 'initial' }">
            {{ r.type }}
          </div>
          <!-- nombre del Agente -->
          <div class="column">{{ r.agent }}</div>
          <!-- Monto del subtotal -->
          <div class="column">
            {{ r.currency }} {{ displayFormat(r.amount) }}
          </div>
          <!-- Monto del iva -->
          <div class="column">
            {{ r.currencyIVA }} {{ displayFormat(r.iva) }}
          </div>
        </div>
      </div>
    </div>
    <!-- --------------------------------- -->
    <!-- --------- DEDUCCIONES ----------- -->
    <!-- --------------------------------- -->
    <div class="title-section"><h2>Deducciones</h2></div>
    <div class="content-section deduction">
      <ng-container *ngFor="let d of deductionsKeys">
        <!-- TABLA -->
        <div class="custom-table deduction-table" *ngIf="deductionList[d]">
          <!-- HEADER -->
          <div class="t-header">
            <div class="column">{{ deductionList[d]?.name }}</div>
          </div>
          <!-- BODY -->
          <!-- DEDUCCION POR JURISTICCION AL TIPO DE AGENTE ↓ -->
          <div
            class="t-row deduction"
            *ngIf="deductionList[d]?.jurisdictionDeduction"
          >
            <div class="line-key-value">
              <span>Deducción por jurisdicción al tipo de agente</span>
            </div>
            <div class="line-key-value">
              <span>%</span>
              <h3>
                {{
                  displayFormat(
                    deductionList[d]?.jurisdictionDeduction?.percentage
                  )
                }}
              </h3>
              <span>U$S:</span>
              <h3>
                {{
                  displayFormat(deductionList[d]?.jurisdictionDeduction?.usd)
                }}
              </h3>
              <span>$:</span>
              <h3>
                {{
                  displayFormat(deductionList[d]?.jurisdictionDeduction?.local)
                }}
              </h3>
            </div>
          </div>
          <!-- DEDUCCION MANUAL AL AGENTE ↓ -->
          <div
            class="t-row deduction"
            *ngIf="deductionList[d]?.manualDeduction"
          >
            <div class="line-key-value">
              <span>
                Deducción:
                {{ deductionList[d]?.manualDeduction?.nameDeduction }}
              </span>
            </div>
            <div class="line-key-value">
              <span>U$S:</span>
              <h3>
                {{ displayFormat(deductionList[d]?.manualDeduction?.usd) }}
              </h3>
              <span>$:</span>
              <h3>
                {{ displayFormat(deductionList[d]?.manualDeduction?.local) }}
              </h3>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <!-- --------------------------------- -->
    <!-- ------------ NOTAS -------------- -->
    <!-- --------------------------------- -->
    <div class="title-section" *ngIf="data.reservationNotes || data.notes">
      <h2>Notas</h2>
    </div>
    <div class="content-section" *ngIf="data.reservationNotes || data.notes">
      <div class="note-title">Notas de la reserva:</div>
      <div class="note-content">
        {{ data.reservationNotes || "-" }}
      </div>
      <div class="note-title">Notas de la rendición:</div>
      <div class="note-content">
        {{ data.notes || "-" }}
      </div>
    </div>
  </div>

  <!-- -------------------------------------------------------------- -->
  <!-- -------------------------------------------------------------- -->
  <!-- -------------------------------------------------------------- -->
  <!-- ------------------------ COMISIONES -------------------------- -->
  <!-- -------------------------------------------------------------- -->
  <!-- -------------------------------------------------------------- -->
  <!-- -------------------------------------------------------------- -->

  <div class="commission-container" *ngIf="isReadyCheckout">
    <div class="title-section"><h2>Comisiones</h2></div>
    <!-- ------------------------------------------------------------ -->
    <!-- --------------------- PRECIO DE CIERRE --------------------- -->
    <!-- ------------------------------------------------------------ -->
    <!-- en referido a cobrar no se muestra precio de cierre -->
    <div
      class="line-box"
      *ngIf="data.renditionType != 2 && data.renditionType != 5"
    >
      <h4>Precio de cierre</h4>
      <div class="amount-container">
        <div class="amount-item" *ngIf="!isOnlyLocal">
          U$S
          <h5>{{ dataCheckout.closedPrice.usd | number: "1.0-2" }}</h5>
        </div>
        <div class="amount-item" *ngIf="!isOnlyUsd">
          $
          <h5>{{ dataCheckout.closedPrice.local | number: "1.0-2" }}</h5>
        </div>
      </div>
    </div>

    <!-- ------------------------------------------------------------ -->
    <!-- ---------------------- COMISIÓN BRUTA ---------------------- -->
    <!-- ------------------------------------------------------------ -->
    <!-- en referido a cobrar no se muestra comisión bruta -->
    <div
      class="line-box"
      *ngIf="data.renditionType != 2 && data.renditionType != 5"
    >
      <h4>Comisión bruta</h4>
      <div class="amount-container">
        <div class="amount-item percentage">
          %
          <h5>
            {{ dataCheckout.rawCommission.percentage | number: "1.0-2" }}
          </h5>
        </div>
        <div class="amount-item" *ngIf="!isOnlyLocal">
          U$S
          <h5>{{ dataCheckout.rawCommission.usd | number: "1.0-2" }}</h5>
        </div>
        <div class="amount-item" *ngIf="!isOnlyUsd">
          $
          <h5>{{ dataCheckout.rawCommission.local | number: "1.0-2" }}</h5>
        </div>
      </div>
    </div>
    <!-- ------------------------------------------------------------- -->
    <!-- ---------------------- PUNTA VENDEDORA ---------------------- -->
    <!-- ------------------------------------------------------------- -->
    <div
      class="line-box"
      *ngIf="data.renditionType != 2 && data.renditionType != 5"
    >
      <!-- SI ES CUALQUIER RENDICION MENOS REFERIDO/BORRADOR-REFERIDO -->
      <h4 *ngIf="data.renditionType != 2 && data.renditionType != 5">
        Punta {{ this.NODE === this.NODE_DO ? "captadora" : "vendedora" }} ({{
          dataCheckout.seller.relation | number: "1.0-2"
        }}%)
      </h4>
      <div class="amount-container">
        <div class="amount-item percentage">
          %
          <h5>{{ dataCheckout.seller.percentage | number: "1.0-2" }}</h5>
        </div>
        <div class="amount-item" *ngIf="!isOnlyLocal">
          U$S
          <h5>
            {{ dataCheckout.seller.usd + cobrokerUSD | number: "1.0-2" }}
          </h5>
        </div>
        <div class="amount-item" *ngIf="!isOnlyUsd">
          $
          <h5>
            {{ dataCheckout.seller.local + cobrokerLocal | number: "1.0-2" }}
          </h5>
        </div>
      </div>
      <!---- PUNTA VENDEDORA: DETALLES ---->
      <!----- 📦 CAJA AGENTE VENDEDOR ----->
      <div
        class="detailed-content"
        *ngIf="
          !dataCheckout.seller.officeId &&
          !dataCheckout.seller.otherRealEstateName
        "
      >
        <!-- nombre agente -->
        <div class="detailed-item highlighted">
          <p>Agente: {{ dataCheckout.seller.agent.name }}</p>
        </div>
        <!-- comision bruta -->
        <div class="detailed-item">
          <p>Comisión bruta</p>
          <div class="detailed-amount-container">
            <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
              U$S
              <span>{{ dataCheckout.seller.usd | number: "1.0-2" }}</span>
            </div>
            <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
              $
              <span>{{ dataCheckout.seller.local | number: "1.0-2" }}</span>
            </div>
          </div>
        </div>
        <!-- deducción manual -->
        <div
          class="detailed-item"
          *ngIf="dataCheckout.seller.agent.manualDeduction.name"
        >
          <p>Deducción: {{ dataCheckout.seller.agent.manualDeduction.name }}</p>
          <div class="detailed-amount-container">
            <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
              U$S
              <span
                >-
                {{
                  dataCheckout.seller.agent.manualDeduction.usd
                    | number: "1.0-2"
                }}</span
              >
            </div>
            <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
              $
              <span
                >-
                {{
                  dataCheckout.seller.agent.manualDeduction.local
                    | number: "1.0-2"
                }}</span
              >
            </div>
          </div>
        </div>
        <!-- Descuento Referido -->
        <div class="detailed-item" *ngIf="dataCheckout.seller.referred.name">
          <p>
            Referido ({{
              dataCheckout.seller.referred.rawCommission.percentage
            }}%)
          </p>
          <div class="detailed-amount-container">
            <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
              U$S
              <span
                >-
                {{
                  dataCheckout.seller.referred.rawCommission.usd
                    | number: "1.0-2"
                }}</span
              >
            </div>
            <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
              $
              <span
                >-
                {{
                  dataCheckout.seller.referred.rawCommission.local
                    | number: "1.0-2"
                }}</span
              >
            </div>
          </div>
        </div>
        <!-- Subtotal -->
        <div
          class="detailed-item highlighted divider"
          *ngIf="
            dataCheckout.seller.referred.name ||
            dataCheckout.seller.agent.manualDeduction.name
          "
        >
          <p>Subtotal</p>
          <div class="detailed-amount-container">
            <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
              U$S
              <span>{{
                dataCheckout.seller.agent.firstSubtotal.usd | number: "1.0-2"
              }}</span>
            </div>
            <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
              $
              <span>{{
                dataCheckout.seller.agent.firstSubtotal.local | number: "1.0-2"
              }}</span>
            </div>
          </div>
        </div>
        <!-- Descuento Team leader -->
        <div class="detailed-item" *ngIf="dataCheckout.seller.teamLeader.name">
          <p>Team leader</p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.teamLeader.rawCommission.usd > 0"
            >
              U$S
              <span
                >-
                {{
                  dataCheckout.seller.teamLeader.rawCommission.usd
                    | number: "1.0-2"
                }}</span
              >
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.teamLeader.rawCommission.local > 0"
            >
              $
              <span
                >-
                {{
                  dataCheckout.seller.teamLeader.rawCommission.local
                    | number: "1.0-2"
                }}</span
              >
            </div>
          </div>
        </div>
        <!-- Subtotal CON TEAM LEADER -->
        <div
          class="detailed-item highlighted divider"
          *ngIf="dataCheckout.seller.teamLeader.name"
        >
          <p>Subtotal</p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.agent.secondSubtotal.usd > 0"
            >
              U$S
              <span>{{
                dataCheckout.seller.agent.secondSubtotal.usd | number: "1.0-2"
              }}</span>
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.agent.secondSubtotal.local > 0"
            >
              $
              <span>{{
                dataCheckout.seller.agent.secondSubtotal.local | number: "1.0-2"
              }}</span>
            </div>
          </div>
        </div>
        <!-- Desc. Oficina -->
        <div class="detailed-item">
          <p *ifNodeShow="[NODE_AR, NODE_GLOBAL]">
            Desc. Oficina
            {{
              100 -
                this.dataAgentTypes[this.dataCheckout.seller.agent.type.name]
            }}% ({{
              dataCheckout.seller.agent.type.name == "TEAM_JUNIOR"
                ? "T. Member"
                : dataCheckout.seller.agent.type.name
            }}
            {{
              this.dataAgentTypes[this.dataCheckout.seller.agent.type.name]
            }}%)
          </p>
          <p *ifNodeShow="[NODE_DO]">
            Desc. Oficina
            {{
              100 -
                this.dataAgentTypes[this.dataCheckout.seller.agent.type.name]
            }}% ({{
              dataCheckout.seller.agent.type.original === "JUNIOR"
                ? "T. Member"
                : ""
            }}
            {{
              this.dataAgentTypes[this.dataCheckout.seller.agent.type.name]
            }}%)
          </p>
          <div class="detailed-amount-container">
            <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
              U$S
              <span
                >-
                {{ dataCheckout.seller.agent.type.usd | number: "1.0-2" }}</span
              >
            </div>
            <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
              $
              <span
                >-
                {{
                  dataCheckout.seller.agent.type.local | number: "1.0-2"
                }}</span
              >
            </div>
          </div>
        </div>
        <!-- Desc. al tipo de agente por jurisdiccion -->
        <div
          class="detailed-item"
          *ngIf="dataCheckout.seller.agent.deduction.percentage > 0"
        >
          <p>
            Deducción agente
            {{
              dataCheckout.seller.agent.deduction.percentage | number: "1.0-2"
            }}%
          </p>
          <div class="detailed-amount-container">
            <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
              U$S
              <span
                >-
                {{
                  dataCheckout.seller.agent.deduction.usd | number: "1.0-2"
                }}</span
              >
            </div>
            <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
              $
              <span
                >-
                {{
                  dataCheckout.seller.agent.deduction.local | number: "1.0-2"
                }}</span
              >
            </div>
          </div>
        </div>
        <!-- Desc. ABAO -->
        <div
          class="detailed-item"
          *ngIf="
            dataCheckout.seller.agent.abao.usd > 0 ||
            dataCheckout.seller.agent.abao.local > 0
          "
        >
          <p>ABAO FC Agente a Oficina</p>
          <div class="detailed-amount-container">
            <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
              U$S
              <span
                >-
                {{ dataCheckout.seller.agent.abao.usd | number: "1.0-2" }}</span
              >
            </div>
            <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
              $
              <span
                >-
                {{
                  dataCheckout.seller.agent.abao.local | number: "1.0-2"
                }}</span
              >
            </div>
          </div>
        </div>
        <!-- Comisión neta -->
        <div class="detailed-item highlighted divider">
          <p>Comisión neta</p>
          <div class="detailed-amount-container">
            <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
              U$S
              <span>{{
                dataCheckout.seller.agent.netCommission.usd | number: "1.0-2"
              }}</span>
            </div>
            <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
              $
              <span>{{
                dataCheckout.seller.agent.netCommission.local | number: "1.0-2"
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 📦 CAJA PUNTA DE OTRA OFICINA/INMOBILIARIA VENDEDORA -->
      <div
        class="detailed-content"
        *ngIf="
          dataCheckout.seller.officeId ||
          dataCheckout.seller.otherRealEstateName
        "
      >
        <div class="detailed-item highlighted">
          <p *ngIf="dataCheckout.seller.officeId">
            Agente: {{ dataCheckout.seller.agent.name }} (RE/MAX
            {{ getOfficeName(dataCheckout.seller.officeId) }})
          </p>
          <p *ngIf="dataCheckout.seller.otherRealEstateName">
            Agente: {{ dataCheckout.seller.agent.name }} (Inmobiliria
            {{ dataCheckout.seller.otherRealEstateName }})
          </p>
          <div class="detailed-amount-container">
            <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
              U$S
              <span>{{ displayFormat(dataCheckout.seller.usd) }}</span>
            </div>
            <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
              $
              <span>{{ displayFormat(dataCheckout.seller.local) }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 📦 CAJA REFERIDO VENDEDOR -->
      <div
        class="detailed-content"
        *ngIf="
          dataCheckout.seller.referred.name && dataCheckout.seller.agent.office
        "
      >
        <!-- SI EL REFERIDO ES DE MI OFICINA -->
        <ng-container
          *ngIf="
            this.referredList.seller?.officeID == myOfficeID;
            else noMyOfficeRefSeller
          "
        >
          <!-- nombre agente referido -->
          <div class="detailed-item highlighted">
            <p>Referido: {{ dataCheckout.seller.referred.name }}</p>
          </div>
          <!-- comision bruta -->
          <div class="detailed-item">
            <p>Comisión bruta</p>
            <div class="detailed-amount-container">
              <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
                U$S
                <span>{{
                  dataCheckout.seller.referred.rawCommission.usd
                    | number: "1.0-2"
                }}</span>
              </div>
              <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
                $
                <span>{{
                  dataCheckout.seller.referred.rawCommission.local
                    | number: "1.0-2"
                }}</span>
              </div>
            </div>
          </div>
          <!-- Desc. Oficina -->
          <div class="detailed-item">
            <p *ifNodeShow="[NODE_AR, NODE_GLOBAL]">
              Desc. Oficina
              {{
                100 -
                  this.dataAgentTypes[
                    this.dataCheckout.seller.referred.type.name
                  ]
              }}% ({{
                dataCheckout.seller.referred.type.name == "TEAM_JUNIOR"
                  ? "T. Member"
                  : dataCheckout.seller.referred.type.name
              }}
              {{
                this.dataAgentTypes[
                  this.dataCheckout.seller.referred.type.name
                ]
              }}%)
            </p>
            <p *ifNodeShow="[NODE_DO]">
              Desc. Oficina
              {{
                100 -
                  this.dataAgentTypes[
                    this.dataCheckout.seller.referred.type.name
                  ]
              }}% ({{
                dataCheckout.seller.referred.type.original == "JUNIOR"
                  ? "T. Member"
                  : ""
              }}
              {{
                this.dataAgentTypes[
                  this.dataCheckout.seller.referred.type.name
                ]
              }}%)
            </p>
            <div class="detailed-amount-container">
              <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
                U$S
                <span
                  >-
                  {{
                    dataCheckout.seller.referred.type.usd | number: "1.0-2"
                  }}</span
                >
              </div>
              <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
                $
                <span
                  >-
                  {{
                    dataCheckout.seller.referred.type.local | number: "1.0-2"
                  }}</span
                >
              </div>
            </div>
          </div>
          <!-- Desc. al tipo de agente por jurisdiccion -->
          <div
            class="detailed-item"
            *ngIf="dataCheckout.seller.referred.agentDeduction.percentage > 0"
          >
            <p>
              Deducción agente
              {{
                dataCheckout.seller.referred.agentDeduction.percentage
                  | number: "1.0-2"
              }}%
            </p>
            <div class="detailed-amount-container">
              <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
                U$S
                <span
                  >-
                  {{
                    dataCheckout.seller.referred.agentDeduction.usd
                      | number: "1.0-2"
                  }}</span
                >
              </div>
              <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
                $
                <span
                  >-
                  {{
                    dataCheckout.seller.referred.agentDeduction.local
                      | number: "1.0-2"
                  }}</span
                >
              </div>
            </div>
          </div>
          <!-- Desc. por facturacion ABAO -->
          <div
            class="detailed-item"
            *ngIf="
              dataCheckout.seller.referred.abao.local > 0 ||
              dataCheckout.seller.referred.abao.usd > 0
            "
          >
            <p>ABAO FC Referido a oficina</p>
            <div class="detailed-amount-container">
              <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
                U$S
                <span
                  >-
                  {{
                    dataCheckout.seller.referred.abao.usd | number: "1.0-2"
                  }}</span
                >
              </div>
              <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
                $
                <span
                  >-
                  {{
                    dataCheckout.seller.referred.abao.local | number: "1.0-2"
                  }}</span
                >
              </div>
            </div>
          </div>
          <!-- Comisión neta -->
          <div class="detailed-item highlighted divider">
            <p>Comisión neta</p>
            <div class="detailed-amount-container">
              <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
                U$S
                <span>{{
                  dataCheckout.seller.referred.netCommission.usd
                    | number: "1.0-2"
                }}</span>
              </div>
              <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
                $
                <span>{{
                  dataCheckout.seller.referred.netCommission.local
                    | number: "1.0-2"
                }}</span>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- SI EL REFERIDO NO ES DE MI OFICINA (REMAX U OTRO) -->
        <ng-template #noMyOfficeRefSeller>
          <div class="detailed-item highlighted">
            <p
              *ngIf="
                referredList?.seller?.officeID &&
                referredList?.seller?.officeID != -1
              "
            >
              Referido: {{ dataCheckout.seller.referred.name }} (RE/MAX
              {{ dataCheckout.seller.referred.officeId }})
            </p>
            <p
              *ngIf="
                referredList.seller?.officeID &&
                referredList.seller?.officeID == -1
              "
            >
              Referido: {{ dataCheckout.seller.referred.name }}
              {{ dataCheckout.seller.referred.officeId }}
            </p>
            <div class="detailed-amount-container">
              <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
                U$S
                <span>{{
                  displayFormat(dataCheckout.seller.referred.netCommission.usd)
                }}</span>
              </div>
              <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
                $
                <span>{{
                  displayFormat(
                    dataCheckout.seller.referred.netCommission.local
                  )
                }}</span>
              </div>
            </div>
          </div>
        </ng-template>
      </div>

      <!-- 📦 CAJA TEAM LEADER -->
      <div class="detailed-content" *ngIf="dataCheckout.seller.teamLeader.name">
        <!-- nombre agente referido -->
        <div class="detailed-item highlighted">
          <p>T. Leader: {{ dataCheckout.seller.teamLeader.name }}</p>
        </div>
        <!-- comision bruta -->
        <div class="detailed-item">
          <p>Comisión bruta</p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.teamLeader.rawCommission.usd > 0"
            >
              U$S
              <span>{{
                dataCheckout.seller.teamLeader.rawCommission.usd
                  | number: "1.0-2"
              }}</span>
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.teamLeader.rawCommission.local > 0"
            >
              $
              <span>{{
                dataCheckout.seller.teamLeader.rawCommission.local
                  | number: "1.0-2"
              }}</span>
            </div>
          </div>
        </div>
        <!-- Desc. Oficina -->
        <div class="detailed-item">
          <p *ifNodeShow="[NODE_AR, NODE_GLOBAL]">
            Desc. Oficina 20% (T. Member 80%)
          </p>
          <p *ifNodeShow="[NODE_DO]">
            Desc. Oficina
            {{
              100 -
                this.dataAgentTypes[
                  this.dataCheckout.seller.teamLeader.type.name
                ]
            }}% (T. Leader
            {{
              this.dataAgentTypes[
                this.dataCheckout.seller.teamLeader.type.name
              ]
            }}%)
          </p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.teamLeader.type.usd > 0"
            >
              U$S
              <span
                >-
                {{
                  dataCheckout.seller.teamLeader.type.usd | number: "1.0-2"
                }}</span
              >
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.teamLeader.type.local > 0"
            >
              $
              <span
                >-
                {{
                  dataCheckout.seller.teamLeader.type.local | number: "1.0-2"
                }}</span
              >
            </div>
          </div>
        </div>
        <!-- Desc. al tipo de agente por jurisdiccion -->
        <div
          class="detailed-item"
          *ngIf="dataCheckout.seller.teamLeader.agentDeduction.percentage > 0"
        >
          <p>
            Deducción agente
            {{ dataCheckout.seller.teamLeader.agentDeduction.local }}%
          </p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.teamLeader.agentDeduction.usd > 0"
            >
              U$S
              <span
                >-
                {{
                  dataCheckout.seller.teamLeader.agentDeduction.usd
                    | number: "1.0-2"
                }}</span
              >
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.teamLeader.agentDeduction.local > 0"
            >
              $
              <span
                >-
                {{
                  dataCheckout.seller.teamLeader.agentDeduction.local
                    | number: "1.0-2"
                }}</span
              >
            </div>
          </div>
        </div>
        <!-- Comisión neta -->
        <div class="detailed-item highlighted divider">
          <p>Comisión neta</p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.teamLeader.netCommission.usd > 0"
            >
              U$S
              <span>{{
                dataCheckout.seller.teamLeader.netCommission.usd
                  | number: "1.0-2"
              }}</span>
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.teamLeader.netCommission.local > 0"
            >
              $
              <span>{{
                dataCheckout.seller.teamLeader.netCommission.local
                  | number: "1.0-2"
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 📦 CAJAS COBROKERS -->
      <ng-container *ifNodeShow="[NODE_DO]">
        <ng-container
          *ngFor="let cobroker of dataCheckout.cobrokers; let i = index"
        >
          <div class="detailed-content" *ngIf="cobroker.name">
            <!-- SI EL COBROKER ES DE MI OFICINA -->
            <ng-container
              *ngIf="
                cobroker.office && !cobroker.officeId;
                else noMyOfficeRefSeller
              "
            >
              <!-- nombre agente referido -->
              <div class="detailed-item highlighted">
                <p>Cobroker #{{ i + 1 }}: {{ cobroker.name }}</p>
              </div>
              <!-- comision bruta -->
              <div class="detailed-item">
                <p>Comisión bruta</p>
                <div class="detailed-amount-container">
                  <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
                    U$S
                    <span>{{
                      cobroker.rawCommission.usd | number: "1.0-2"
                    }}</span>
                  </div>
                  <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
                    $
                    <span>{{
                      cobroker.rawCommission.local | number: "1.0-2"
                    }}</span>
                  </div>
                </div>
              </div>
              <!-- Desc. Oficina -->
              <div class="detailed-item">
                <p>
                  Desc. Oficina
                  {{ 100 - this.dataAgentTypes[cobroker.type.name] }}% ({{
                    cobroker.type.original == "JUNIOR" ? "T. Member" : ""
                  }}
                  {{ this.dataAgentTypes[cobroker.type.name] }}%)
                </p>
                <div class="detailed-amount-container">
                  <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
                    U$S
                    <span>- {{ cobroker.type.usd | number: "1.0-2" }}</span>
                  </div>
                  <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
                    $
                    <span>- {{ cobroker.type.local | number: "1.0-2" }}</span>
                  </div>
                </div>
              </div>
              <!-- Desc. al tipo de agente por jurisdiccion -->
              <div
                class="detailed-item"
                *ngIf="cobroker.agentDeduction.percentage > 0"
              >
                <p>
                  Deducción agente
                  {{ cobroker.agentDeduction.percentage | number: "1.0-2" }}%
                </p>
                <div class="detailed-amount-container">
                  <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
                    U$S
                    <span
                      >-
                      {{ cobroker.agentDeduction.usd | number: "1.0-2" }}</span
                    >
                  </div>
                  <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
                    $
                    <span
                      >-
                      {{
                        cobroker.agentDeduction.local | number: "1.0-2"
                      }}</span
                    >
                  </div>
                </div>
              </div>

              <!-- Comisión neta -->
              <div class="detailed-item highlighted divider">
                <p>Comisión neta</p>
                <div class="detailed-amount-container">
                  <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
                    U$S
                    <span>{{
                      cobroker.netCommission.usd | number: "1.0-2"
                    }}</span>
                  </div>
                  <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
                    $
                    <span>{{
                      cobroker.netCommission.local | number: "1.0-2"
                    }}</span>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- SI EL REFERIDO NO ES DE MI OFICINA (REMAX U OTRO) -->
            <ng-template #noMyOfficeRefSeller>
              <div class="detailed-item highlighted">
                <p
                  *ngIf="
                    cobroker.office && cobroker.officeId;
                    else otherrealestate
                  "
                >
                  Cobroker {{ i + 1 }}: {{ cobroker.name }} (RE/MAX
                  {{ cobroker.office }})
                </p>
                <ng-template #otherrealestate>
                  <p>
                    Cobroker {{ i + 1 }}: {{ cobroker.name }} (Otra
                    inmobiliaria: {{ cobroker.otherRealEstateName }})
                  </p>
                </ng-template>
                <div class="detailed-amount-container">
                  <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
                    U$S
                    <span>{{ displayFormat(cobroker.netCommission.usd) }}</span>
                  </div>
                  <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
                    $
                    <span>{{
                      displayFormat(cobroker.netCommission.local)
                    }}</span>
                  </div>
                </div>
              </div>
            </ng-template>
          </div>

          <!-- COBROKER TEAMLEADER -->

          <div class="detailed-content" *ngIf="cobroker.teamLeader.name">
            <!-- nombre agente referido -->
            <div class="detailed-item highlighted">
              <p>
                T. Leader Cobroker #{{ i + 1 }}: {{ cobroker.teamLeader.name }}
              </p>
            </div>
            <!-- comision bruta -->
            <div class="detailed-item">
              <p>Comisión bruta</p>
              <div class="detailed-amount-container">
                <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
                  U$S
                  <span>{{
                    cobroker.teamLeader.rawCommission.usd | number: "1.0-2"
                  }}</span>
                </div>
                <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
                  $
                  <span>{{
                    cobroker.teamLeader.rawCommission.local | number: "1.0-2"
                  }}</span>
                </div>
              </div>
            </div>
            <!-- Desc. Oficina -->
            <div class="detailed-item">
              <p>
                Desc. Oficina
                {{ 100 - this.dataAgentTypes[cobroker.teamLeader.type.name] }}%
                ( T. Leader

                {{ this.dataAgentTypes[cobroker.teamLeader.type.name] }}%)
              </p>
              <div class="detailed-amount-container">
                <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
                  U$S
                  <span
                    >-
                    {{ cobroker.teamLeader.type.usd | number: "1.0-2" }}</span
                  >
                </div>
                <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
                  $
                  <span
                    >-
                    {{ cobroker.teamLeader.type.local | number: "1.0-2" }}</span
                  >
                </div>
              </div>
            </div>
            <!-- Desc. al tipo de agente por jurisdiccion -->
            <div
              class="detailed-item"
              *ngIf="cobroker.teamLeader.agentDeduction.percentage > 0"
            >
              <p>
                Deducción agente
                {{
                  cobroker.teamLeader.agentDeduction.percentage
                    | number: "1.0-2"
                }}%
              </p>
              <div class="detailed-amount-container">
                <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
                  U$S
                  <span
                    >-
                    {{
                      cobroker.teamLeader.agentDeduction.usd | number: "1.0-2"
                    }}</span
                  >
                </div>
                <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
                  $
                  <span
                    >-
                    {{
                      cobroker.teamLeader.agentDeduction.local | number: "1.0-2"
                    }}</span
                  >
                </div>
              </div>
            </div>

            <!-- Comisión neta -->
            <div class="detailed-item highlighted divider">
              <p>Comisión neta</p>
              <div class="detailed-amount-container">
                <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
                  U$S
                  <span>{{
                    cobroker.teamLeader.netCommission.usd | number: "1.0-2"
                  }}</span>
                </div>
                <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
                  $
                  <span>{{
                    cobroker.teamLeader.netCommission.local | number: "1.0-2"
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>

    <!-- ------------------------------------------------------------- -->
    <!-- ---------------------- REFERIDO A COBRAR ---------------------- -->
    <!-- ------------------------------------------------------------- -->
    <div class="line-box" *ngIf="dataCheckout.referred.isReferred">
      <h4>Agente referenciador</h4>
      <div class="amount-container">
        <div class="amount-item percentage">
          %
          <h5>100%</h5>
        </div>
        <div class="amount-item" *ngIf="dataCheckout.rawCommission.usd > 0">
          U$S
          <h5>{{ dataCheckout.rawCommission.usd | number: "1.0-2" }}</h5>
        </div>
        <div class="amount-item" *ngIf="dataCheckout.rawCommission.local > 0">
          $
          <h5>{{ dataCheckout.rawCommission.local | number: "1.0-2" }}</h5>
        </div>
      </div>
      <div class="detailed-content">
        <!-- nombre agente -->
        <div class="detailed-item highlighted">
          <p>Agente: {{ dataCheckout.referred.name }}</p>
        </div>
        <!-- comision bruta -->
        <div class="detailed-item">
          <p>Comisión bruta</p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.rawCommission.usd > 0"
            >
              U$S
              <span>{{
                dataCheckout.rawCommission.usd | number: "1.0-2"
              }}</span>
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.rawCommission.local > 0"
            >
              $
              <span>{{
                dataCheckout.rawCommission.local | number: "1.0-2"
              }}</span>
            </div>
          </div>
        </div>
        <!-- deducción manual -->
        <div
          class="detailed-item"
          *ngIf="dataCheckout.referred.manualDeduction.name"
        >
          <p>Deducción: {{ dataCheckout.referred.manualDeduction.name }}</p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.referred.manualDeduction.usd > 0"
            >
              U$S
              <span
                >-
                {{
                  dataCheckout.referred.manualDeduction.usd | number: "1.0-2"
                }}</span
              >
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.referred.manualDeduction.local > 0"
            >
              $
              <span
                >-
                {{
                  dataCheckout.referred.manualDeduction.local | number: "1.0-2"
                }}</span
              >
            </div>
          </div>
        </div>
        <!-- Subtotal -->
        <div
          class="detailed-item highlighted divider"
          *ngIf="dataCheckout.referred.manualDeduction.name"
        >
          <p>Subtotal</p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.referred.firstSubtotal.usd > 0"
            >
              U$S
              <span>{{
                dataCheckout.referred.firstSubtotal.usd | number: "1.0-2"
              }}</span>
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.referred.firstSubtotal.local > 0"
            >
              $
              <span>{{
                dataCheckout.referred.firstSubtotal.local | number: "1.0-2"
              }}</span>
            </div>
          </div>
        </div>
        <!-- Descuento Team leader -->
        <div class="detailed-item" *ngIf="dataCheckout.seller.teamLeader.name">
          <p>Team leader</p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.teamLeader.rawCommission.usd > 0"
            >
              U$S
              <span
                >-
                {{
                  dataCheckout.seller.teamLeader.rawCommission.usd
                    | number: "1.0-2"
                }}</span
              >
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.teamLeader.rawCommission.local > 0"
            >
              $
              <span
                >-
                {{
                  dataCheckout.seller.teamLeader.rawCommission.local
                    | number: "1.0-2"
                }}</span
              >
            </div>
          </div>
        </div>
        <!-- Subtotal CON TEAM LEADER -->
        <div
          class="detailed-item highlighted divider"
          *ngIf="dataCheckout.seller.teamLeader.name"
        >
          <p>Subtotal</p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.agent.secondSubtotal.usd > 0"
            >
              U$S
              <span>{{
                dataCheckout.seller.agent.secondSubtotal.usd | number: "1.0-2"
              }}</span>
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.agent.secondSubtotal.local > 0"
            >
              $
              <span>{{
                dataCheckout.seller.agent.secondSubtotal.local | number: "1.0-2"
              }}</span>
            </div>
          </div>
        </div>
        <!-- Desc. Oficina -->
        <div class="detailed-item">
          <p *ifNodeShow="[NODE_AR, NODE_GLOBAL]">
            Desc. Oficina
            {{
              100 - this.dataAgentTypes[this.dataCheckout.referred.type.name]
            }}% ({{
              dataCheckout.referred.type.name == "TEAM_JUNIOR"
                ? "T. Member"
                : dataCheckout.referred.type.name
            }}
            {{ this.dataAgentTypes[this.dataCheckout.referred.type.name] }}%)
          </p>
          <p *ifNodeShow="[NODE_DO]">
            Desc. Oficina
            {{
              100 - this.dataAgentTypes[this.dataCheckout.referred.type.name]
            }}% ({{
              dataCheckout.referred.type.name == "JUNIOR" ? "T. Member" : ""
            }}
            {{ this.dataAgentTypes[this.dataCheckout.referred.type.name] }}%)
          </p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.referred.type.usd > 0"
            >
              U$S
              <span
                >- {{ dataCheckout.referred.type.usd | number: "1.0-2" }}</span
              >
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.referred.type.local > 0"
            >
              $
              <span
                >-
                {{ dataCheckout.referred.type.local | number: "1.0-2" }}</span
              >
            </div>
          </div>
        </div>
        <!-- Desc. al tipo de agente por jurisdiccion -->
        <div
          class="detailed-item"
          *ngIf="dataCheckout.referred.deduction.percentage > 0"
        >
          <p>
            Deducción agente
            {{ dataCheckout.referred.deduction.percentage | number: "1.0-2" }}%
          </p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.referred.deduction.usd > 0"
            >
              U$S
              <span
                >-
                {{
                  dataCheckout.referred.deduction.usd | number: "1.0-2"
                }}</span
              >
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.referred.deduction.local > 0"
            >
              $
              <span
                >-
                {{
                  dataCheckout.referred.deduction.local | number: "1.0-2"
                }}</span
              >
            </div>
          </div>
        </div>
        <!-- Desc. ABAO -->
        <div
          class="detailed-item"
          *ngIf="
            dataCheckout.referred.abao.usd > 0 ||
            dataCheckout.referred.abao.local > 0
          "
        >
          <p>ABAO FC Agente a Oficina</p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.referred.abao.usd > 0"
            >
              U$S
              <span
                >- {{ dataCheckout.referred.abao.usd | number: "1.0-2" }}</span
              >
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.referred.abao.local > 0"
            >
              $
              <span
                >-
                {{ dataCheckout.referred.abao.local | number: "1.0-2" }}</span
              >
            </div>
          </div>
        </div>
        <!-- Comisión neta -->
        <div class="detailed-item highlighted divider">
          <p>Comisión neta</p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.referred.netCommission.usd > 0"
            >
              U$S
              <span>{{
                dataCheckout.referred.netCommission.usd | number: "1.0-2"
              }}</span>
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.referred.netCommission.local > 0"
            >
              $
              <span>{{
                dataCheckout.referred.netCommission.local | number: "1.0-2"
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 📦 CAJA TEAM LEADER -->
      <div class="detailed-content" *ngIf="dataCheckout.seller.teamLeader.name">
        <!-- nombre agente referido -->
        <div class="detailed-item highlighted">
          <p>T. Leader: {{ dataCheckout.seller.teamLeader.name }}</p>
        </div>
        <!-- comision bruta -->
        <div class="detailed-item">
          <p>Comisión bruta</p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.teamLeader.rawCommission.usd > 0"
            >
              U$S
              <span>{{
                dataCheckout.seller.teamLeader.rawCommission.usd
                  | number: "1.0-2"
              }}</span>
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.teamLeader.rawCommission.local > 0"
            >
              $
              <span>{{
                dataCheckout.seller.teamLeader.rawCommission.local
                  | number: "1.0-2"
              }}</span>
            </div>
          </div>
        </div>
        <!-- Desc. Oficina -->
        <div class="detailed-item">
          <p *ifNodeShow="[NODE_AR, NODE_GLOBAL]">
            Desc. Oficina 20% (T. Member 80%)
          </p>
          <p *ifNodeShow="[NODE_DO]">
            Desc. Oficina
            {{
              100 - this.dataAgentTypes[this.dataCheckout.referred.type.name]
            }}% ( T. Leader

            {{ this.dataAgentTypes[this.dataCheckout.referred.type.name] }}%)
          </p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.teamLeader.type.usd > 0"
            >
              U$S
              <span
                >-
                {{
                  dataCheckout.seller.teamLeader.type.usd | number: "1.0-2"
                }}</span
              >
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.teamLeader.type.local > 0"
            >
              $
              <span
                >-
                {{
                  dataCheckout.seller.teamLeader.type.local | number: "1.0-2"
                }}</span
              >
            </div>
          </div>
        </div>
        <!-- Desc. al tipo de agente por jurisdiccion -->
        <div
          class="detailed-item"
          *ngIf="dataCheckout.seller.teamLeader.agentDeduction.percentage > 0"
        >
          <p>
            Deducción agente
            {{ dataCheckout.seller.teamLeader.agentDeduction.local }}%
          </p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.teamLeader.agentDeduction.usd > 0"
            >
              U$S
              <span
                >-
                {{
                  dataCheckout.seller.teamLeader.agentDeduction.usd
                    | number: "1.0-2"
                }}</span
              >
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.teamLeader.agentDeduction.local > 0"
            >
              $
              <span
                >-
                {{
                  dataCheckout.seller.teamLeader.agentDeduction.local
                    | number: "1.0-2"
                }}</span
              >
            </div>
          </div>
        </div>
        <!-- Comisión neta -->
        <div class="detailed-item highlighted divider">
          <p>Comisión neta</p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.teamLeader.netCommission.usd > 0"
            >
              U$S
              <span>{{
                dataCheckout.seller.teamLeader.netCommission.usd
                  | number: "1.0-2"
              }}</span>
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.teamLeader.netCommission.local > 0"
            >
              $
              <span>{{
                dataCheckout.seller.teamLeader.netCommission.local
                  | number: "1.0-2"
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ------------------------------------------------------------- -->
    <!-- ---------------------- PUNTA COMPRADORA --------------------- -->
    <!-- ------------------------------------------------------------- -->
    <div
      class="line-box"
      *ngIf="data.renditionType != 2 && data.renditionType != 5"
    >
      <h4>
        Punta {{ this.NODE === this.NODE_DO ? "vendedora" : "compradora" }} ({{
          dataCheckout.buyer.relation | number: "1.0-2"
        }}%)
      </h4>
      <div class="amount-container">
        <div class="amount-item percentage">
          %
          <h5>{{ dataCheckout.buyer.percentage | number: "1.0-2" }}</h5>
        </div>
        <div class="amount-item" *ngIf="!isOnlyLocal">
          U$S
          <h5>{{ dataCheckout.buyer.usd | number: "1.0-2" }}</h5>
        </div>
        <div class="amount-item" *ngIf="!isOnlyUsd">
          $
          <h5>{{ dataCheckout.buyer.local | number: "1.0-2" }}</h5>
        </div>
      </div>

      <!---- PUNTA COMPRADORA: DETALLES ---->
      <!----- 📦 CAJA AGENTE COMPRADOR ----->
      <div
        class="detailed-content"
        *ngIf="
          !dataCheckout.buyer.officeId &&
          !dataCheckout.buyer.otherRealEstateName
        "
      >
        <!-- nombre agente -->
        <div class="detailed-item highlighted">
          <p>Agente: {{ dataCheckout.buyer.agent.name }}</p>
        </div>
        <!-- comision bruta -->
        <div class="detailed-item">
          <p>Comisión bruta</p>
          <div class="detailed-amount-container">
            <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
              U$S
              <span>{{ dataCheckout.buyer.usd }}</span>
            </div>
            <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
              $
              <span>{{ dataCheckout.buyer.local | number: "1.0-2" }}</span>
            </div>
          </div>
        </div>
        <!-- deducción manual -->
        <div
          class="detailed-item"
          *ngIf="dataCheckout.buyer.agent.manualDeduction.name"
        >
          <p>Deducción: nombre de deducción</p>
          <div class="detailed-amount-container">
            <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
              U$S
              <span
                >-
                {{
                  dataCheckout.buyer.agent.manualDeduction.usd | number: "1.0-2"
                }}</span
              >
            </div>
            <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
              $
              <span
                >-
                {{
                  dataCheckout.buyer.agent.manualDeduction.local
                    | number: "1.0-2"
                }}</span
              >
            </div>
          </div>
        </div>
        <!-- Descuento Referido -->
        <div class="detailed-item" *ngIf="dataCheckout.buyer.referred.name">
          <p>
            Referido ({{
              dataCheckout.buyer.referred.rawCommission.percentage
            }}%)
          </p>
          <div class="detailed-amount-container">
            <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
              U$S
              <span
                >-
                {{
                  dataCheckout.buyer.referred.rawCommission.usd
                    | number: "1.0-2"
                }}</span
              >
            </div>
            <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
              $
              <span
                >-
                {{
                  dataCheckout.buyer.referred.rawCommission.local
                    | number: "1.0-2"
                }}</span
              >
            </div>
          </div>
        </div>
        <!-- Subtotal -->
        <div
          class="detailed-item highlighted divider"
          *ngIf="
            dataCheckout.buyer.referred.name ||
            dataCheckout.buyer.agent.manualDeduction.name
          "
        >
          <p>Subtotal</p>
          <div class="detailed-amount-container">
            <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
              U$S
              <span>{{
                dataCheckout.buyer.agent.firstSubtotal.usd | number: "1.0-2"
              }}</span>
            </div>
            <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
              $
              <span>{{
                dataCheckout.buyer.agent.firstSubtotal.local | number: "1.0-2"
              }}</span>
            </div>
          </div>
        </div>
        <!-- Descuento Team leader -->
        <div class="detailed-item" *ngIf="dataCheckout.buyer.teamLeader.name">
          <p>Team leader</p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.buyer.teamLeader.rawCommission.usd > 0"
            >
              U$S
              <span
                >-
                {{
                  dataCheckout.buyer.teamLeader.rawCommission.usd
                    | number: "1.0-2"
                }}</span
              >
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.buyer.teamLeader.rawCommission.local > 0"
            >
              $
              <span
                >-
                {{
                  dataCheckout.buyer.teamLeader.rawCommission.local
                    | number: "1.0-2"
                }}</span
              >
            </div>
          </div>
        </div>
        <!-- Subtotal CON TEAM LEADER -->
        <div
          class="detailed-item highlighted divider"
          *ngIf="dataCheckout.buyer.teamLeader.name"
        >
          <p>Subtotal</p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.buyer.agent.secondSubtotal.usd > 0"
            >
              U$S
              <span>{{
                dataCheckout.buyer.agent.secondSubtotal.usd | number: "1.0-2"
              }}</span>
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.buyer.agent.secondSubtotal.local > 0"
            >
              $
              <span>{{
                dataCheckout.buyer.agent.secondSubtotal.local | number: "1.0-2"
              }}</span>
            </div>
          </div>
        </div>
        <!-- Desc. Oficina -->
        <div class="detailed-item">
          <p *ifNodeShow="[NODE_AR, NODE_GLOBAL]">
            Desc. Oficina
            {{
              100 -
                this.dataAgentTypes[this.dataCheckout.buyer.agent.type.name]
            }}% ({{
              dataCheckout.buyer.agent.type.name == "TEAM_JUNIOR"
                ? "T. Member"
                : dataCheckout.buyer.agent.type.name
            }}
            {{ this.dataAgentTypes[this.dataCheckout.buyer.agent.type.name] }}%)
          </p>
          <p *ifNodeShow="[NODE_DO]">
            Desc. Oficina
            {{
              100 -
                this.dataAgentTypes[this.dataCheckout.buyer.agent.type.name]
            }}% ({{
              dataCheckout.buyer.agent.type.original == "JUNIOR"
                ? "T. Member"
                : ""
            }}
            {{ this.dataAgentTypes[this.dataCheckout.buyer.agent.type.name] }}%)
          </p>
          <div class="detailed-amount-container">
            <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
              U$S
              <span
                >-
                {{ dataCheckout.buyer.agent.type.usd | number: "1.0-2" }}
              </span>
            </div>
            <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
              $
              <span
                >-
                {{ dataCheckout.buyer.agent.type.local | number: "1.0-2" }}
              </span>
            </div>
          </div>
        </div>
        <!-- Desc. al tipo de agente por jurisdiccion -->
        <div
          class="detailed-item"
          *ngIf="dataCheckout.buyer.agent.deduction.percentage > 0"
        >
          <p>
            Deducción agente
            {{
              dataCheckout.buyer.agent.deduction.percentage | number: "1.0-2"
            }}
            %
          </p>
          <div class="detailed-amount-container">
            <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
              U$S
              <span
                >-
                {{ dataCheckout.buyer.agent.deduction.usd | number: "1.0-2" }}
              </span>
            </div>
            <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
              $
              <span
                >-
                {{ dataCheckout.buyer.agent.deduction.local | number: "1.0-2" }}
              </span>
            </div>
          </div>
        </div>
        <!-- Desc. al tipo de agente por jurisdiccion -->
        <div
          class="detailed-item"
          *ngIf="
            dataCheckout.buyer.agent.abao.usd > 0 ||
            dataCheckout.buyer.agent.abao.local > 0
          "
        >
          <p>ABAO FC Agente a Oficina</p>
          <div class="detailed-amount-container">
            <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
              U$S
              <span
                >-
                {{ dataCheckout.buyer.agent.abao.usd | number: "1.0-2" }}</span
              >
            </div>
            <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
              $
              <span
                >-
                {{ dataCheckout.buyer.agent.abao.local | number: "1.0-2" }}
              </span>
            </div>
          </div>
        </div>
        <!-- Comisión neta -->
        <div class="detailed-item highlighted divider">
          <p>Comisión neta</p>
          <div class="detailed-amount-container">
            <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
              U$S
              <span>{{
                dataCheckout.buyer.agent.netCommission.usd | number: "1.0-2"
              }}</span>
            </div>
            <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
              $
              <span>{{
                dataCheckout.buyer.agent.netCommission.local | number: "1.0-2"
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 📦 CAJA PUNTA DE OTRA OFICINA/INMOBILIARIA COMPRADOR -->
      <div
        class="detailed-content"
        *ngIf="
          dataCheckout.buyer.officeId || dataCheckout.buyer.otherRealEstateName
        "
      >
        <div class="detailed-item highlighted">
          <p *ngIf="dataCheckout.buyer.officeId">
            Agente: {{ dataCheckout.buyer.agent.name }} (RE/MAX
            {{ getOfficeName(dataCheckout.buyer.officeId) }})
          </p>
          <p *ngIf="dataCheckout.buyer.otherRealEstateName">
            Agente: {{ dataCheckout.buyer.agent.name }} (Inmobiliria
            {{ dataCheckout.buyer.otherRealEstateName }})
          </p>
          <div class="detailed-amount-container">
            <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
              U$S
              <span>{{ displayFormat(dataCheckout.buyer.usd) }}</span>
            </div>
            <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
              $
              <span>{{ displayFormat(dataCheckout.buyer.local) }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 📦 CAJA REFERIDO COMPRADOR -->
      <div
        class="detailed-content"
        *ngIf="
          dataCheckout.buyer.referred.name && dataCheckout.buyer.agent.office
        "
      >
        <!-- REFERIDO COMPRADOR DE MI OFICINA -->
        <ng-container
          *ngIf="
            this.referredList.buyer?.officeID == myOfficeID;
            else noMyOfficeRefBuyer
          "
        >
          <!-- nombre agente referido -->
          <div class="detailed-item highlighted">
            <p>Referido: {{ dataCheckout.buyer.referred.name }}</p>
          </div>
          <!-- comision bruta -->
          <div class="detailed-item">
            <p>Comisión bruta</p>
            <div class="detailed-amount-container">
              <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
                U$S
                <span>{{
                  dataCheckout.buyer.referred.rawCommission.usd
                    | number: "1.0-2"
                }}</span>
              </div>
              <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
                $
                <span>{{
                  dataCheckout.buyer.referred.rawCommission.local
                    | number: "1.0-2"
                }}</span>
              </div>
            </div>
          </div>
          <!-- Desc. Oficina -->
          <div class="detailed-item">
            <p *ifNodeShow="[NODE_AR, NODE_GLOBAL]">
              Desc. Oficina
              {{
                100 -
                  this.dataAgentTypes[
                    this.dataCheckout.buyer.referred.type.name
                  ]
              }}% ({{
                dataCheckout.buyer.referred.type.name == "TEAM_JUNIOR"
                  ? "T. Member"
                  : dataCheckout.buyer.referred.type.name
              }}
              {{
                this.dataAgentTypes[this.dataCheckout.buyer.referred.type.name]
              }}%)
            </p>
            <p *ifNodeShow="[NODE_DO]">
              Desc. Oficina
              {{
                100 -
                  this.dataAgentTypes[
                    this.dataCheckout.buyer.referred.type.name
                  ]
              }}% ({{
                dataCheckout.buyer.referred.type.original == "JUNIOR"
                  ? "T. Member"
                  : ""
              }}
              {{
                this.dataAgentTypes[this.dataCheckout.buyer.referred.type.name]
              }}%)
            </p>
            <div class="detailed-amount-container">
              <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
                U$S
                <span
                  >-
                  {{
                    dataCheckout.buyer.referred.type.usd | number: "1.0-2"
                  }}</span
                >
              </div>
              <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
                $
                <span
                  >-
                  {{
                    dataCheckout.buyer.referred.type.local | number: "1.0-2"
                  }}</span
                >
              </div>
            </div>
          </div>
          <!-- Desc. al tipo de agente por jurisdiccion -->
          <div
            class="detailed-item"
            *ngIf="dataCheckout.buyer.referred.agentDeduction.percentage > 0"
          >
            <p>
              Deducción agente
              {{
                dataCheckout.buyer.referred.agentDeduction.percentage
                  | number: "1.0-2"
              }}%
            </p>
            <div class="detailed-amount-container">
              <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
                U$S
                <span
                  >-
                  {{
                    dataCheckout.buyer.referred.agentDeduction.usd
                      | number: "1.0-2"
                  }}</span
                >
              </div>
              <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
                $
                <span
                  >-
                  {{
                    dataCheckout.buyer.referred.agentDeduction.local
                      | number: "1.0-2"
                  }}</span
                >
              </div>
            </div>
          </div>
          <!-- Desc. por facturacion ABAO -->
          <div
            class="detailed-item"
            *ngIf="
              dataCheckout.buyer.referred.abao.local > 0 ||
              dataCheckout.buyer.referred.abao.usd > 0
            "
          >
            <p>ABAO FC Referido a oficina</p>
            <div class="detailed-amount-container">
              <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
                U$S
                <span
                  >-
                  {{
                    dataCheckout.buyer.referred.abao.usd | number: "1.0-2"
                  }}</span
                >
              </div>
              <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
                $
                <span
                  >-
                  {{
                    dataCheckout.buyer.referred.abao.local | number: "1.0-2"
                  }}</span
                >
              </div>
            </div>
          </div>
          <!-- Comisión neta -->
          <div class="detailed-item highlighted divider">
            <p>Comisión neta</p>
            <div class="detailed-amount-container">
              <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
                U$S
                <span>{{
                  dataCheckout.buyer.referred.netCommission.usd
                    | number: "1.0-2"
                }}</span>
              </div>
              <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
                $
                <span>{{
                  dataCheckout.buyer.referred.netCommission.local
                    | number: "1.0-2"
                }}</span>
              </div>
            </div>
          </div>
        </ng-container>
        <!-- REFERIDO COMPRADOR DE OTRO REMAX/OTRO-->
        <ng-template #noMyOfficeRefBuyer>
          <div class="detailed-item highlighted">
            <p
              *ngIf="
                referredList?.buyer?.officeID &&
                referredList?.buyer?.officeID != -1
              "
            >
              Referido: {{ dataCheckout.buyer.referred.name }} (RE/MAX
              {{ dataCheckout.buyer.referred.officeId }})
            </p>
            <p
              *ngIf="
                referredList.buyer?.officeID &&
                referredList.buyer?.officeID == -1
              "
            >
              Referido: {{ dataCheckout.buyer.referred.name }}
              {{ dataCheckout.buyer.referred.officeId }}
            </p>
            <div class="detailed-amount-container">
              <div class="detailed-amount-item" *ngIf="!isOnlyLocal">
                U$S
                <span>{{
                  displayFormat(dataCheckout.buyer.referred.netCommission.usd)
                }}</span>
              </div>
              <div class="detailed-amount-item" *ngIf="!isOnlyUsd">
                $
                <span>{{
                  displayFormat(dataCheckout.buyer.referred.netCommission.local)
                }}</span>
              </div>
            </div>
          </div>
        </ng-template>
      </div>

      <!-- 📦 CAJA TEAM LEADER -->
      <div class="detailed-content" *ngIf="dataCheckout.buyer.teamLeader.name">
        <!-- nombre agente referido -->
        <div class="detailed-item highlighted">
          <p>Team Leader: {{ dataCheckout.buyer.teamLeader.name }}</p>
        </div>
        <!-- comision bruta -->
        <div class="detailed-item">
          <p>Comisión bruta</p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.buyer.teamLeader.rawCommission.usd > 0"
            >
              U$S
              <span>{{
                dataCheckout.buyer.teamLeader.rawCommission.usd
                  | number: "1.0-2"
              }}</span>
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.buyer.teamLeader.rawCommission.local > 0"
            >
              $
              <span>{{
                dataCheckout.buyer.teamLeader.rawCommission.local
                  | number: "1.0-2"
              }}</span>
            </div>
          </div>
        </div>
        <!-- Desc. Oficina -->
        <div class="detailed-item">
          <p *ifNodeShow="[NODE_AR, NODE_GLOBAL]">
            Desc. Oficina 20% (T. Member 80%)
          </p>
          <p *ifNodeShow="[NODE_DO]">
            Desc. Oficina
            {{
              100 -
                this.dataAgentTypes[
                  this.dataCheckout.buyer.teamLeader.type.name
                ]
            }}% (T. Leader

            {{
              this.dataAgentTypes[this.dataCheckout.buyer.teamLeader.type.name]
            }}%)
          </p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.buyer.teamLeader.type.usd > 0"
            >
              U$S
              <span
                >-
                {{
                  dataCheckout.buyer.teamLeader.type.usd | number: "1.0-2"
                }}</span
              >
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.buyer.teamLeader.type.local > 0"
            >
              $
              <span
                >-
                {{
                  dataCheckout.buyer.teamLeader.type.local | number: "1.0-2"
                }}</span
              >
            </div>
          </div>
        </div>
        <!-- Desc. al tipo de agente por jurisdiccion -->
        <div
          class="detailed-item"
          *ngIf="dataCheckout.buyer.teamLeader.agentDeduction.percentage > 0"
        >
          <p>
            Deducción agente
            {{ dataCheckout.buyer.teamLeader.agentDeduction.local }}%
          </p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.buyer.teamLeader.agentDeduction.usd > 0"
            >
              U$S
              <span
                >-
                {{
                  dataCheckout.buyer.teamLeader.agentDeduction.usd
                    | number: "1.0-2"
                }}</span
              >
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.buyer.teamLeader.agentDeduction.local > 0"
            >
              $
              <span
                >-
                {{
                  dataCheckout.buyer.teamLeader.agentDeduction.local
                    | number: "1.0-2"
                }}</span
              >
            </div>
          </div>
        </div>
        <!-- Comisión neta -->
        <div class="detailed-item highlighted divider">
          <p>Comisión neta</p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.buyer.teamLeader.netCommission.usd > 0"
            >
              U$S
              <span>{{
                dataCheckout.buyer.teamLeader.netCommission.usd
                  | number: "1.0-2"
              }}</span>
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.buyer.teamLeader.netCommission.local > 0"
            >
              $
              <span>{{
                dataCheckout.buyer.teamLeader.netCommission.local
                  | number: "1.0-2"
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ------------------------------------------------------------ -->
    <!-- -------------------------- OFICINA ------------------------- -->
    <!-- ------------------------------------------------------------ -->

    <div class="line-box">
      <h4>Oficina</h4>
      <div class="amount-container">
        <div class="amount-item percentage">
          %
          <h5>
            {{ dataCheckout.office.rawCommission.percentage | number: "1.0-2" }}
          </h5>
        </div>
        <div
          class="amount-item"
          *ngIf="dataCheckout.office.rawCommission.usd > 0"
        >
          U$S
          <h5>
            {{ dataCheckout.office.rawCommission.usd | number: "1.0-2" }}
          </h5>
        </div>
        <div
          class="amount-item"
          *ngIf="dataCheckout.office.rawCommission.local > 0"
        >
          $
          <h5>
            {{ dataCheckout.office.rawCommission.local | number: "1.0-2" }}
          </h5>
        </div>
      </div>
      <!-- DETALLE -->
      <div class="detailed-content">
        <!-- comision bruta operación -->
        <div class="detailed-item">
          <p>Comisión bruta de la operación</p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.rawCommission.usd > 0"
            >
              U$S
              <span>{{
                dataCheckout.rawCommission.usd | number: "1.0-2"
              }}</span>
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.rawCommission.local > 0"
            >
              $
              <span>{{
                dataCheckout.rawCommission.local | number: "1.0-2"
              }}</span>
            </div>
          </div>
        </div>

        <!-- Desc. cobroker externo -->
        <ng-container
          *ngFor="let cobroker of dataCheckout.cobrokers; let i = index"
        >
          <div
            class="detailed-item"
            *ngIf="cobroker.officeId || cobroker.otherRealEstateName"
          >
            <p>
              Descuento: Cobroker #{{ i + 1 }} ({{
                cobroker.otherRealEstateName
                  ? cobroker.otherRealEstateName
                  : "Otro RE/MAX"
              }})
            </p>
            <div class="detailed-amount-container">
              <div
                class="detailed-amount-item"
                *ngIf="cobroker.rawCommission.usd > 0"
              >
                U$S
                <span
                  >- {{ cobroker.rawCommission.usd | number: "1.0-2" }}</span
                >
              </div>
              <div
                class="detailed-amount-item"
                *ngIf="cobroker.rawCommission.local > 0"
              >
                $
                <span
                  >- {{ cobroker.rawCommission.local | number: "1.0-2" }}</span
                >
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Desc. punta de otra oficina (VENDEDORA) -->
        <div
          class="detailed-item"
          *ngIf="
            dataCheckout.seller.officeId ||
            dataCheckout.seller.otherRealEstateName
          "
        >
          <p>
            Descuento: Punta
            {{ this.NODE === this.NODE_DO ? "captadora" : "vendedora" }} ({{
              dataCheckout.seller.otherRealEstateName
                ? dataCheckout.seller.otherRealEstateName
                : "RE/MAX " + getOfficeName(dataCheckout.seller.officeId)
            }})
          </p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.usd > 0"
            >
              U$S
              <span>- {{ dataCheckout.seller.usd | number: "1.0-2" }}</span>
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.local > 0"
            >
              $
              <span>- {{ dataCheckout.seller.local | number: "1.0-2" }}</span>
            </div>
          </div>
        </div>
        <!-- Desc. punta de otra oficina (COMPRADORA) -->
        <div
          class="detailed-item"
          *ngIf="
            dataCheckout.buyer.officeId ||
            dataCheckout.buyer.otherRealEstateName
          "
        >
          <p>
            Descuento: Punta
            {{ this.NODE === this.NODE_DO ? "vendedora" : "compradora" }} ({{
              dataCheckout.buyer.otherRealEstateName
                ? dataCheckout.buyer.otherRealEstateName
                : "RE/MAX " + getOfficeName(dataCheckout.buyer.officeId)
            }})
          </p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.buyer.usd > 0"
            >
              U$S
              <span>- {{ dataCheckout.buyer.usd | number: "1.0-2" }}</span>
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.buyer.local > 0"
            >
              $
              <span>- {{ dataCheckout.buyer.local | number: "1.0-2" }}</span>
            </div>
          </div>
        </div>
        <!-- Desc. referido comprador de otra oficina/inmobiliria -->
        <div
          class="detailed-item"
          *ngIf="
            referredList.seller && referredList.seller.officeID != myOfficeID
          "
        >
          <p>
            Descuento: Referido
            {{ this.NODE === this.NODE_DO ? "captador" : "vendedor" }} ({{
              referredList.seller.officeID == -1
                ? "Otro"
                : "RE/MAX " + getOfficeName(referredList.seller.officeID)
            }})
          </p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.referred.rawCommission.usd > 0"
            >
              U$S
              <span
                >-
                {{
                  dataCheckout.seller.referred.rawCommission.usd
                    | number: "1.0-2"
                }}</span
              >
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.referred.rawCommission.local > 0"
            >
              $
              <span
                >-
                {{
                  dataCheckout.seller.referred.rawCommission.local
                    | number: "1.0-2"
                }}</span
              >
            </div>
          </div>
        </div>
        <!-- Desc. referido vendedor de otra oficina/inmobiliria -->
        <div
          class="detailed-item"
          *ngIf="
            referredList.buyer && referredList.buyer.officeID != myOfficeID
          "
        >
          <p>
            Descuento: Referido
            {{ this.NODE === this.NODE_DO ? "vendedor" : "comprador" }} ({{
              referredList.buyer.officeID == -1
                ? "Otro"
                : "RE/MAX " + getOfficeName(referredList.buyer.officeID)
            }})
          </p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.buyer.referred.rawCommission.usd > 0"
            >
              U$S
              <span
                >-
                {{
                  dataCheckout.buyer.referred.rawCommission.usd
                    | number: "1.0-2"
                }}</span
              >
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.buyer.referred.rawCommission.local > 0"
            >
              $
              <span
                >-
                {{
                  dataCheckout.buyer.referred.rawCommission.local
                    | number: "1.0-2"
                }}</span
              >
            </div>
          </div>
        </div>
        <!-- ------------------------------------------------------------------------------ -->
        <!-- SUBTOTAL | Comisión bruta resultante (RESTANDO REFERIDOS AJENOS y PUNTA AJENA) -->
        <div
          class="detailed-item highlighted divider"
          *ngIf="showSubtotalOffice() && !this.dataCheckout.referred.isReferred"
        >
          <p>
            Comisión bruta oficina ({{
              dataCheckout.office.subtotal.percentage | number: "1.0-2"
            }}%)
          </p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.office.subtotal.usd > 0"
            >
              U$S
              <span>{{
                dataCheckout.office.subtotal.usd | number: "1.0-2"
              }}</span>
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.office.subtotal.local > 0"
            >
              $
              <span>{{
                dataCheckout.office.subtotal.local | number: "1.0-2"
              }}</span>
            </div>
          </div>
        </div>

        <!-- A pagar referido a cobrar -->
        <div class="detailed-item" *ngIf="dataCheckout.referred.isReferred">
          <p>A pagar agente</p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.referred.netCommission.usd > 0"
            >
              U$S
              <span
                >-
                {{
                  dataCheckout.referred.netCommission.usd | number: "1.0-2"
                }}</span
              >
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.referred.netCommission.local > 0"
            >
              $
              <span
                >-
                {{
                  dataCheckout.referred.netCommission.local | number: "1.0-2"
                }}</span
              >
            </div>
          </div>
        </div>

        <!-- A pagar agente vendedor -->
        <div
          class="detailed-item"
          *ngIf="
            !dataCheckout.seller.officeId &&
            !dataCheckout.seller.otherRealEstateName &&
            !dataCheckout.referred.isReferred
          "
        >
          <p>
            A pagar agente ({{
              this.NODE === this.NODE_DO ? "captador" : "vendedor"
            }})
          </p>
          <div
            class="detailed-amount-container"
            *ngIf="
              !dataCheckout.seller.officeId &&
              !dataCheckout.seller.otherRealEstateName
            "
          >
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.agent.netCommission.usd > 0"
            >
              U$S
              <span
                >-
                {{
                  dataCheckout.seller.agent.netCommission.usd | number: "1.0-2"
                }}</span
              >
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.agent.netCommission.local > 0"
            >
              $
              <span
                >-
                {{
                  dataCheckout.seller.agent.netCommission.local
                    | number: "1.0-2"
                }}</span
              >
            </div>
          </div>
        </div>
        <!-- A pagar referido vendedor -->
        <div
          class="detailed-item"
          *ngIf="referredList.seller?.officeID == myOfficeID"
        >
          <p>
            A pagar referido ({{
              this.NODE === this.NODE_DO ? "captador" : "vendedor"
            }})
          </p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.referred.netCommission.usd > 0"
            >
              U$S
              <span
                >-
                {{
                  dataCheckout.seller.referred.netCommission.usd
                    | number: "1.0-2"
                }}</span
              >
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.referred.netCommission.local > 0"
            >
              $
              <span
                >-
                {{
                  dataCheckout.seller.referred.netCommission.local
                    | number: "1.0-2"
                }}</span
              >
            </div>
          </div>
        </div>
        <!-- A pagar team leader vendedor -->
        <div class="detailed-item" *ngIf="dataCheckout.seller.teamLeader.name">
          <p>
            A pagar team leader ({{
              this.NODE === this.NODE_DO ? "captador" : "vendedor"
            }})
          </p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.teamLeader.netCommission.usd > 0"
            >
              U$S
              <span
                >-
                {{
                  dataCheckout.seller.teamLeader.netCommission.usd
                    | number: "1.0-2"
                }}</span
              >
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.seller.teamLeader.netCommission.local > 0"
            >
              $
              <span
                >-
                {{
                  dataCheckout.seller.teamLeader.netCommission.local
                    | number: "1.0-2"
                }}</span
              >
            </div>
          </div>
        </div>
        <!-- A pagar cobroker propio -->
        <ng-container
          *ngFor="let cobroker of dataCheckout.cobrokers; let i = index"
        >
          <div
            class="detailed-item"
            *ngIf="cobroker.office && !cobroker.officeId"
          >
            <p>A pagar cobroker ({{ cobroker.name }})</p>
            <div class="detailed-amount-container">
              <div
                class="detailed-amount-item"
                *ngIf="cobroker.netCommission.usd > 0"
              >
                U$S
                <span
                  >- {{ cobroker.netCommission.usd | number: "1.0-2" }}</span
                >
              </div>
              <div
                class="detailed-amount-item"
                *ngIf="cobroker.netCommission.local > 0"
              >
                $
                <span
                  >- {{ cobroker.netCommission.local | number: "1.0-2" }}</span
                >
              </div>
            </div>
          </div>

          <!-- A pagar cobroker teamleaderpropio -->

          <div class="detailed-item" *ngIf="cobroker.teamLeader.name">
            <p>A pagar cobroker teamleader ({{ cobroker.teamLeader.name }})</p>
            <div class="detailed-amount-container">
              <div
                class="detailed-amount-item"
                *ngIf="cobroker.teamLeader.netCommission.usd > 0"
              >
                U$S
                <span
                  >-
                  {{
                    cobroker.teamLeader.netCommission.usd | number: "1.0-2"
                  }}</span
                >
              </div>
              <div
                class="detailed-amount-item"
                *ngIf="cobroker.teamLeader.netCommission.local > 0"
              >
                $
                <span
                  >-
                  {{
                    cobroker.teamLeader.netCommission.local | number: "1.0-2"
                  }}</span
                >
              </div>
            </div>
          </div>
        </ng-container>

        <!-- A pagar agente comprador -->
        <div
          class="detailed-item"
          *ngIf="
            !dataCheckout.buyer.officeId &&
            !dataCheckout.buyer.otherRealEstateName &&
            !dataCheckout.referred.isReferred
          "
        >
          <p>
            A pagar agente ({{
              this.NODE === this.NODE_DO ? "vendedor" : "comprador"
            }})
          </p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.buyer.agent.netCommission.usd > 0"
            >
              U$S
              <span
                >-
                {{
                  dataCheckout.buyer.agent.netCommission.usd | number: "1.0-2"
                }}</span
              >
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.buyer.agent.netCommission.local > 0"
            >
              $
              <span
                >-
                {{
                  dataCheckout.buyer.agent.netCommission.local | number: "1.0-2"
                }}</span
              >
            </div>
          </div>
        </div>
        <!-- A pagar referido comprador -->
        <div
          class="detailed-item"
          *ngIf="referredList.buyer?.officeID == myOfficeID"
        >
          <p>
            A pagar referido ({{
              this.NODE === this.NODE_DO ? "vendedor" : "comprador"
            }})
          </p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.buyer.referred.netCommission.usd > 0"
            >
              U$S
              <span
                >-
                {{
                  dataCheckout.buyer.referred.netCommission.usd
                    | number: "1.0-2"
                }}</span
              >
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.buyer.referred.netCommission.local > 0"
            >
              $
              <span
                >-
                {{
                  dataCheckout.buyer.referred.netCommission.local
                    | number: "1.0-2"
                }}</span
              >
            </div>
          </div>
        </div>
        <!-- A pagar team leader comprador -->
        <div class="detailed-item" *ngIf="dataCheckout.buyer.teamLeader.name">
          <p>
            A pagar team leader ({{
              this.NODE === this.NODE_DO ? "vendedor" : "comprador"
            }})
          </p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.buyer.teamLeader.netCommission.usd > 0"
            >
              U$S
              <span
                >-
                {{
                  dataCheckout.buyer.teamLeader.netCommission.usd
                    | number: "1.0-2"
                }}</span
              >
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.buyer.teamLeader.netCommission.local > 0"
            >
              $
              <span
                >-
                {{
                  dataCheckout.buyer.teamLeader.netCommission.local
                    | number: "1.0-2"
                }}</span
              >
            </div>
          </div>
        </div>
        <!-- Comisión neta -->
        <div class="detailed-item highlighted divider">
          <p>Comisión neta</p>
          <!-- Detalle comisión AR - PY - EC -->
          <div
            class="detailed-amount-container"
            *ngIf="this.NODE !== this.NODE_GLOBAL"
          >
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.office.netCommission.usd > 0"
            >
              U$S
              <span>{{
                dataCheckout.office.netCommission.usd | number: "1.0-2"
              }}</span>
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.office.netCommission.local > 0"
            >
              $
              <span>{{
                dataCheckout.office.netCommission.local | number: "1.0-2"
              }}</span>
            </div>
          </div>
          <!-- Detalle comisión Global -->
          <div
            class="detailed-amount-container"
            *ngIf="this.NODE === this.NODE_GLOBAL"
          >
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.office.subtotal.usd > 0"
            >
              U$S
              <span>{{
                dataCheckout.office.netCommission.usd | number: "1.0-2"
              }}</span>
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.office.subtotal.local > 0"
            >
              $
              <span>{{
                dataCheckout.office.netCommission.local | number: "1.0-2"
              }}</span>
            </div>
          </div>
        </div>
        <!-- Caja previsional -->
        <!-- <div class="detailed-item">
          <p>Caja previsional</p>
          <div class="detailed-amount-container">
            <div class="detailed-amount-item">
              U$S
              <span>34</span>
            </div>
            <div class="detailed-amount-item">
              $
              <span>8.000</span>
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <!-- ------------------------------------------------------------ -->
    <!-- ---------------------------- IVA --------------------------- -->
    <!-- ------------------------------------------------------------ -->
    <div
      class="line-box"
      *ngIf="
        dataCheckout.iva.office.usd > 0 ||
        dataCheckout.iva.office.local > 0 ||
        dataCheckout.iva.agent.usd > 0 ||
        dataCheckout.iva.agent.local > 0
      "
    >
      <h4>IVA</h4>
      <div class="detailed-content">
        <!-- IVA OFICINA -->
        <div
          class="detailed-item highlighted"
          *ngIf="
            dataCheckout.iva.office.usd > 0 || dataCheckout.iva.office.local > 0
          "
        >
          <p>IVA Oficina</p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.iva.office.usd > 0"
            >
              U$S
              <span>{{ dataCheckout.iva.office.usd | number: "1.0-2" }}</span>
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.iva.office.local > 0"
            >
              $
              <span>{{ dataCheckout.iva.office.local | number: "1.0-2" }}</span>
            </div>
          </div>
        </div>
        <!-- IVA AGENTE -->
        <div
          class="detailed-item highlighted"
          *ngIf="
            dataCheckout.iva.agent.usd > 0 || dataCheckout.iva.agent.local > 0
          "
        >
          <p>IVA agente</p>
          <div class="detailed-amount-container">
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.iva.agent.usd > 0"
            >
              U$S
              <span>{{ dataCheckout.iva.agent.usd | number: "1.0-2" }}</span>
            </div>
            <div
              class="detailed-amount-item"
              *ngIf="dataCheckout.iva.agent.local > 0"
            >
              $
              <span>{{ dataCheckout.iva.agent.local | number: "1.0-2" }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <p class="declaration">
    Recibi conforme el monto indicado al final de esta declaracion en concepto
    de comision por la operacion antes descrita. Declaro haber percibido el
    total de comisiones correspondientes a esta operacion y acepto los terminos
    y condiciones bajo los cuales se ha calculado el importe a cobrar. Asimismo
    me comprometo a rendir dicho importe en la oficina correspondiente dentro de
    las proximas 24 hrs.
  </p>
</section>
